/* eslint-disable complexity */
import React, {useState, useEffect, useContext} from 'react';
import {ButtonIcon} from '@homeaway/react-buttons';
import {CLOSE__12, CHEVRON_RIGHT__24} from '@homeaway/svg-defs';
import {TrackingContext} from '@homeaway/react-event-tracking';
import Cookies from 'js-cookie';
import {createCookie} from '../utils/cookies';
import {
    handleDismissEdapEvent,
    handleDownloadEdapEvent,
    handleOnloadEdapEvent,
} from '../utils/triggerEdapEvent';
import {BANNER} from '../notification-config';
import './AppDownloadBanner.less';

export const AppDownloadBanner = ({
    imgUrl,
    title,
    description,
    ctaLink,
    useCanonicalPath,
}) => {
    const [showBannerState, setShowBannerState] = useState(null);
    const [bannerPresented, setBannerPresented] = useState(null);
    const [bannerSelected, setBannerSelected] = useState(null);
    const [bannerDismissed, setBannerDismissed] = useState(null);
    const context = useContext(TrackingContext);
    function getDownloadLink(hav, xdid) {
        return `${ctaLink}?hav=${hav}&source_visitor_id=${hav}&source_xdid=${xdid}`;
    }
    const [link, setLink] = useState(
        getDownloadLink(Cookies.get('hav'), Cookies.get('xdid'))
    );
    const [path, setPath] = useState(null);
    useEffect(() => {
        if (useCanonicalPath && typeof window !== 'undefined') {
            setPath(window.location);
        }
    }, [path, useCanonicalPath]);

    useEffect(() => {
        if (bannerSelected || bannerDismissed) {
            setShowBannerState(false);
        } else {
            setShowBannerState(true);
            if (!bannerPresented) {
                handleOnloadEdapEvent(context, BANNER);
            }
            setBannerPresented(true);
        }
    });
    function handleCloseButtonClick(element) {
        setBannerDismissed(true);
        handleDismissEdapEvent(context, BANNER);
        createCookie();
        element.stopPropagation();
    }

    function handleDownloadButtonClick(element) {
        setBannerSelected(true);
        handleDownloadEdapEvent(context, BANNER);
        let ctaAppLink = link;
        if (useCanonicalPath) {
            ctaAppLink = `${ctaAppLink}&$canonical_url=${path}`;
            setLink(ctaAppLink);
        }
        createCookie();
        window.location.href = ctaAppLink;
        element.stopPropagation();
    }
    return (
        <div className="download-banner-box">
            {showBannerState && (
                <div
                    className="download-banner-box__container"
                    role="button"
                    onClick={handleDownloadButtonClick}
                    onKeyDown={handleDownloadButtonClick}
                    tabIndex={0}
                >
                    <div className="download-banner-box__close">
                        <ButtonIcon
                            label="close-button"
                            noBorder
                            size="xs"
                            svgMarkup={CLOSE__12}
                            onClick={handleCloseButtonClick}
                            data-testid="download-banner-close-button"
                        />
                    </div>
                    <div className="download-banner-box__app-icon">
                        <img
                            src={imgUrl}
                            alt="Logo"
                            width="54px"
                            height="54px"
                        />
                    </div>
                    <div className="download-banner-box__content">
                        <p>
                            <strong>{title}</strong>
                        </p>
                        <p className="download-banner-box__description">
                            {description}
                        </p>
                    </div>
                    <div className="download-banner-box__submit">
                        <ButtonIcon
                            label="app-icon"
                            noBorder
                            size="xs"
                            className="download-banner__download-button"
                            data-testid="download-banner-download-button"
                            svgMarkup={CHEVRON_RIGHT__24}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
